<router-outlet></router-outlet>

<ng-template #sessionModal let-c="close" let-d="dismiss" data-backdrop="static">
  <h4 class="modal-title" style="margin-top: -2px">Warning</h4>
  <div style="border-top: 1px solid #dee2e6">
    <div class="container">
      <div class="row">
        <div class="col-md-2">
          <i
            aria-hidden="true"
            class="bento-icon-info"
            style="cursor: pointer; font-size: 3.5em"
          >
          </i>
        </div>

        <div class="col-md-10" style="margin-top: 20px">
          <p>Your Session has expired.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-primary"
      style="margin: 0px 10px"
      (click)="c('confirm')"
    >
      OK
    </button>
  </div>
</ng-template>
